// extracted by mini-css-extract-plugin
export default {"file_detail":"index_file_detail__gTBMW","release_note":"index_release_note__cD-nX"};